const breakpoints = {
  keys: ["xs", "sm", "md", "lg", "xl"],
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1080,
    xl: 1280,
  },
};

export default breakpoints;
